import { render, staticRenderFns } from "./GamificationItemsList.vue?vue&type=template&id=3c1fbb49&scoped=true"
import script from "./GamificationItemsList.vue?vue&type=script&lang=js"
export * from "./GamificationItemsList.vue?vue&type=script&lang=js"
import style0 from "./GamificationItemsList.vue?vue&type=style&index=0&id=3c1fbb49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1fbb49",
  null
  
)

export default component.exports